module.exports = __webpack_public_path__ + "fonts/mc.a077baa.eot";